import { Module, GetterTree, ActionTree, MutationTree } from "vuex";
import { RootState, SiteState } from "./types";
import { SiteSchema } from "./schemas";

export const state: SiteState = new SiteSchema();

const actions: ActionTree<SiteState, RootState> = {
  assignSite({ commit }, data) {
    commit("siteLoaded", data);
  },
  assignTimedOut({ commit }, data) {
    commit("setTimedOut", data);
  },
};

const getters: GetterTree<SiteState, RootState> = {
  getSite(state): SiteState {
    return state;
  },
};

const mutations: MutationTree<SiteState> = {
  siteLoaded(state, payload: SiteState) {
    if (payload instanceof Object) {
      const sd = new SiteSchema(payload);
      Object.keys(payload).forEach((key) => {
        switch (key) {
          case "settings":
            state.settings = sd.settings;
            break;
          case "labels":
            state.labels = sd.labels;
            break;
          case "snippets":
            state.snippets = sd.snippets;
            break;
          case "courses":
            state.courses = sd.courses;
            break;
          case "displayOptions":
            state.displayOptions = sd.displayOptions;
            break;
        }
      });
    }
  },
  setTimedOut(state, payload: boolean) {
    state.timedOut = payload;
  },
};

const namespaced = true;

export const site: Module<SiteState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
